"use client";

import React from "react";
import { Wrench, Loader as Loader2, CircleCheck as CheckCircle2, ShieldCheck, Clock, Settings } from 'lucide-react';
import { FormProvider, useWvcForm } from "@/integrations/forms/FormProvider";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Form, FormField, FormItem, FormLabel, FormControl, FormMessage } from "@/components/ui/form";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
const serviceOptions = ["Standard Tune-up", "Blade Sharpening & Balancing", "Oil & Filter Change", "Engine Diagnostics", "Winterization Service", "Other / Not Sure"];
function ServiceBookingForm() {
  const {
    isSubmitting,
    isSubmitted,
    submitError,
    successMessage,
    handleSubmit,
    resetForm,
    control
  } = useWvcForm();
  if (isSubmitted && !submitError) {
    return <div className="p-8 md:p-12 bg-card border border-border rounded-lg text-center space-y-6 animate-in fade-in zoom-in duration-500 shadow-xl">
        <div className="mx-auto size-20 bg-primary/10 rounded-lg flex items-center justify-center mb-4">
          <CheckCircle2 className="size-10 text-primary" />
        </div>
        <div className="space-y-3">
          <h3 className="text-3xl font-bold font-default text-foreground tracking-tight">Request Received!</h3>
          <p className="text-muted-foreground leading-relaxed max-w-sm mx-auto">{successMessage}</p>
        </div>
        <Button onClick={resetForm} variant="outline" className="mt-6 border-2 rounded-lg px-8 h-12 hover:bg-primary hover:text-primary-foreground transition-all">
          Book Another Service
        </Button>
      </div>;
  }
  return <Form onSubmit={handleSubmit} className="space-y-6 relative z-10">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
        <FormField control={control} name="fullName" rules={{
        required: "Full name is required"
      }} render={({
        field
      }) => <FormItem>
              <FormLabel className="text-sm font-semibold text-foreground/80">
                Full Name
              </FormLabel>
              <FormControl>
                <Input placeholder="John Doe" className="h-12 border-border bg-background focus-visible:ring-primary/30 rounded-lg transition-all" {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>} />

        <FormField control={control} name="phone" rules={{
        required: "Phone number is required",
        pattern: {
          value: /^[0-9+\-\s()]*$/,
          message: "Invalid phone number format"
        }
      }} render={({
        field
      }) => <FormItem>
              <FormLabel className="text-sm font-semibold text-foreground/80">
                Phone Number
              </FormLabel>
              <FormControl>
                <Input type="tel" placeholder="01228 123456" className="h-12 border-border bg-background focus-visible:ring-primary/30 rounded-lg transition-all" {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>} />

        <FormField control={control} name="mowerModel" rules={{
        required: "Mower brand/model is required"
      }} render={({
        field
      }) => <FormItem className="md:col-span-2">
              <FormLabel className="text-sm font-semibold text-foreground/80">
                Mower Brand & Model
              </FormLabel>
              <FormControl>
                <Input placeholder="e.g., Honda HRX217, John Deere S120" className="h-12 border-border bg-background focus-visible:ring-primary/30 rounded-lg transition-all" {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>} />

        <FormField control={control} name="serviceType" rules={{
        required: "Please select a service type"
      }} render={({
        field
      }) => <FormItem className="md:col-span-2">
              <FormLabel className="text-sm font-semibold text-foreground/80">
                Required Service
              </FormLabel>
              <Select onValueChange={field.onChange} defaultValue={field.value}>
                <FormControl>
                  <SelectTrigger className="h-12 border-border bg-background focus-visible:ring-primary/30 rounded-lg transition-all w-full">
                    <SelectValue placeholder="Select primary service needed" />
                  </SelectTrigger>
                </FormControl>
                <SelectContent>
                  {serviceOptions.map((service, i) => <SelectItem key={i} value={service}>
                      {service}
                    </SelectItem>)}
                </SelectContent>
              </Select>
              <FormMessage />
            </FormItem>} />
      </div>

      {submitError && <div className="p-4 bg-destructive/10 border border-destructive/20 rounded-lg">
          <p className="text-sm text-destructive font-medium">{submitError}</p>
        </div>}

      <Button type="submit" disabled={isSubmitting} size="lg" className="w-full h-14 text-base font-bold tracking-wide rounded-lg shadow-md hover:shadow-lg transition-all active:scale-[0.98] bg-primary text-primary-foreground">
        {isSubmitting ? <>
            <Loader2 className="animate-spin mr-2 size-5" />
            Processing...
          </> : "Schedule Service Now"}
      </Button>
    </Form>;
}
export default function GetYourLawnMowerServicedToday() {
  const features = [];
  return <section id="get-your-lawn-mower-serviced-today" className="relative bg-background py-20 md:py-32 overflow-hidden">
      {}
      <div className="absolute inset-0 bg-[radial-gradient(#e5e7eb_1px,transparent_1px)] [background-size:32px_32px] opacity-40" />
      <div className="absolute top-0 left-0 w-full h-full bg-gradient-to-br from-primary/5 via-transparent to-primary/5 pointer-events-none" />
      
      <div className="page-container max-w-6xl relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-16 items-center">
          
          {}
          <div className="lg:col-span-5 space-y-10">
            <div className="space-y-6">
              <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-lg bg-primary/10 text-primary text-xs font-bold uppercase tracking-widest">
                <Wrench className="size-3.5" />
                Professional Maintenance
              </div>
              <h2 className="text-4xl md:text-6xl font-bold font-default text-foreground tracking-tight leading-[1.05]">
                Book Your <span className="text-primary">Service</span> Today
              </h2>
              <p className="text-muted-foreground text-lg leading-relaxed">
                Don't wait for a breakdown. Our expert mechanics in Carlisle provide comprehensive servicing to keep your lawn mower running at peak performance all season long.
              </p>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              {features.map((item, i) => <div key={i} data-index={i} className="group p-5 rounded-lg bg-card border border-border shadow-sm hover:shadow-md hover:border-primary/30 transition-all duration-300">
                  <div className="size-10 rounded-lg bg-primary/5 flex items-center justify-center mb-3 group-hover:bg-primary/10 transition-colors">
                    <item.icon className="size-5 text-primary" />
                  </div>
                  <h4 className="font-bold text-foreground mb-1">{item.title}</h4>
                  <p className="text-sm text-muted-foreground leading-snug">{item.desc}</p>
                </div>)}
            </div>
          </div>

          {}
          <div className="lg:col-span-7">
            <div className="relative">
              {}
              <div className="absolute -inset-4 bg-primary/10 blur-3xl rounded-lg opacity-50 -z-10" />
              
              <div className="w-full bg-card/90 backdrop-blur-md p-8 md:p-12 rounded-lg shadow-2xl border border-border relative overflow-hidden">
                <div className="absolute top-0 right-0 w-40 h-40 bg-primary/5 rounded-lg -mr-20 -mt-20 blur-3xl" />
                
                <div className="mb-8">
                  <h3 className="text-2xl font-bold text-foreground mb-2">Service Request</h3>
                  <p className="text-muted-foreground text-sm">Fill out the form below and we'll get back to you within 24 hours.</p>
                </div>

                <FormProvider formId="lawn-mower-service-booking" sectionName="Get Your Lawn Mower Serviced Today" defaultValues={{
                fullName: "",
                phone: "",
                mowerModel: "",
                serviceType: ""
              }} submitText="Schedule Service Now" successMessage="Your service request has been logged. A technician will contact you shortly to confirm your appointment.">
                  <ServiceBookingForm />
                </FormProvider>
              </div>
            </div>
          </div>

        </div>
      </div>

      {}
      <Wrench className="absolute -bottom-32 -right-32 size-[500px] text-primary/5 -rotate-12 pointer-events-none" aria-hidden="true" />
    </section>;
}